var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photo, Edit/Photo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5H5C3.895 5 3 5.895 3 7V19C3 20.105 3.895 21 5 21H18C19.105 21 20 20.105 20 19V5",
    fill: "#01181B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9674 16.4671L8.4714 14.0811C8.8204 13.5281 9.5974 13.4531 10.0454 13.9291L11.1204 15.0711L12.2474 12.6761C12.5944 11.9381 13.6324 11.9041 14.0274 12.6181L16.1814 16.5161C16.5494 17.1831 16.0664 18.0001 15.3054 18.0001H7.8134C7.0254 18.0001 6.5474 17.1331 6.9674 16.4671Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_30_29818",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 12,
    height: 12,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 12,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0909 3.09091C19.0909 2.48842 18.6025 2 18 2C17.3975 2 16.9091 2.48842 16.9091 3.09091V4.90909H15.0909C14.4884 4.90909 14 5.39751 14 6C14 6.60249 14.4884 7.09091 15.0909 7.09091H16.9091V8.90909C16.9091 9.51158 17.3975 10 18 10C18.6025 10 19.0909 9.51158 19.0909 8.90909V7.09091H20.9091C21.5116 7.09091 22 6.60249 22 6C22 5.39751 21.5116 4.90909 20.9091 4.90909H19.0909V3.09091Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0909 3.09091C19.0909 2.48842 18.6025 2 18 2C17.3975 2 16.9091 2.48842 16.9091 3.09091V4.90909H15.0909C14.4884 4.90909 14 5.39751 14 6C14 6.60249 14.4884 7.09091 15.0909 7.09091H16.9091V8.90909C16.9091 9.51158 17.3975 10 18 10C18.6025 10 19.0909 9.51158 19.0909 8.90909V7.09091H20.9091C21.5116 7.09091 22 6.60249 22 6C22 5.39751 21.5116 4.90909 20.9091 4.90909H19.0909V3.09091Z",
    fill: "#01181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9091 4.90909V6.40909C17.7375 6.40909 18.4091 5.73752 18.4091 4.90909H16.9091ZM16.9091 7.09091H18.4091C18.4091 6.26248 17.7375 5.59091 16.9091 5.59091V7.09091ZM19.0909 7.09091V5.59091C18.2625 5.59091 17.5909 6.26248 17.5909 7.09091H19.0909ZM19.0909 4.90909H17.5909C17.5909 5.73752 18.2625 6.40909 19.0909 6.40909V4.90909ZM18 3.5C17.7741 3.5 17.5909 3.31684 17.5909 3.09091H20.5909C20.5909 1.65999 19.4309 0.5 18 0.5V3.5ZM18.4091 3.09091C18.4091 3.31684 18.2259 3.5 18 3.5V0.5C16.5691 0.5 15.4091 1.65999 15.4091 3.09091H18.4091ZM18.4091 4.90909V3.09091H15.4091V4.90909H18.4091ZM15.0909 6.40909H16.9091V3.40909H15.0909V6.40909ZM15.5 6C15.5 6.22593 15.3168 6.40909 15.0909 6.40909V3.40909C13.66 3.40909 12.5 4.56908 12.5 6H15.5ZM15.0909 5.59091C15.3168 5.59091 15.5 5.77407 15.5 6H12.5C12.5 7.43092 13.66 8.59091 15.0909 8.59091V5.59091ZM16.9091 5.59091H15.0909V8.59091H16.9091V5.59091ZM18.4091 8.90909V7.09091H15.4091V8.90909H18.4091ZM18 8.5C18.2259 8.5 18.4091 8.68316 18.4091 8.90909H15.4091C15.4091 10.34 16.5691 11.5 18 11.5V8.5ZM17.5909 8.90909C17.5909 8.68316 17.7741 8.5 18 8.5V11.5C19.4309 11.5 20.5909 10.34 20.5909 8.90909H17.5909ZM17.5909 7.09091V8.90909H20.5909V7.09091H17.5909ZM20.9091 5.59091H19.0909V8.59091H20.9091V5.59091ZM20.5 6C20.5 5.77407 20.6832 5.59091 20.9091 5.59091V8.59091C22.34 8.59091 23.5 7.43092 23.5 6H20.5ZM20.9091 6.40909C20.6832 6.40909 20.5 6.22593 20.5 6H23.5C23.5 4.56908 22.34 3.40909 20.9091 3.40909V6.40909ZM19.0909 6.40909H20.9091V3.40909H19.0909V6.40909ZM17.5909 3.09091V4.90909H20.5909V3.09091H17.5909Z",
    fill: "#FEFEFE",
    mask: "url(#path-3-outside-1_30_29818)"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 280",
    cx: 8,
    cy: 9,
    r: 2,
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhotoIcon);
export default __webpack_public_path__ + "static/media/upload-photo-icon.2efffc9eaf1d372bb1f87033a55f9e29.svg";
export { ForwardRef as ReactComponent };